import { render, staticRenderFns } from "./BaseAutoHorizonScroll.vue?vue&type=template&id=774cfa1a&scoped=true&"
import script from "./BaseAutoHorizonScroll.vue?vue&type=script&lang=js&"
export * from "./BaseAutoHorizonScroll.vue?vue&type=script&lang=js&"
import style0 from "./BaseAutoHorizonScroll.vue?vue&type=style&index=0&id=774cfa1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774cfa1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('774cfa1a', component.options)
    } else {
      api.reload('774cfa1a', component.options)
    }
    module.hot.accept("./BaseAutoHorizonScroll.vue?vue&type=template&id=774cfa1a&scoped=true&", function () {
      api.rerender('774cfa1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/base_components/BaseAutoHorizonScroll.vue"
export default component.exports